/* BookStores JS Plugin for PC */

if ($('.bookstore-left-preview').length > 0) {
  $('.bookstore-left-preview .mal-dropdown-menu .item').on('click', function(){
    const $item = $(this);
    alert('Item clicked: ' + $item.attr('rel'));
    // TODO: 選択肢をクッキーに保存する処理を追加する
  });
}
